import { render, staticRenderFns } from "./VueHorizontalTimeline.vue?vue&type=template&id=2ed068d4&scoped=true&"
import script from "./VueHorizontalTimeline.vue?vue&type=script&lang=js&"
export * from "./VueHorizontalTimeline.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/style.min.css?vue&type=style&index=0&id=2ed068d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed068d4",
  null
  
)

export default component.exports